<template>
  <view class="pay-order-success">
    <u-icon name="checkmark-circle" size="70" color="tomato" />
    <text>支付成功</text>
    <text class="pay-amount" v-if="payAmount !== null">¥{{ payAmount }}</text>
    <button @click="gotoOrderList">查看订单</button>
    <button @click="gotoHomePage">返回</button>
  </view>
</template>

<script>
export default {
  name: 'PaySuccess',
  props: {
    payAmount: {
      type: Number,
      default: null,
    },
  },
  methods: {
    gotoOrderList() {
      this.$emit('gotoOrderList');
    },
    gotoHomePage() {
      this.$emit('gotoHomePage');
    },
  },
};
</script>

<style scoped lang="scss">
.pay-order-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 50px;
  .pay-amount {
    font-size: 40rpx;
  }
  button {
    width: 240rpx;
    height: 80rpx;
    line-height: 80rpx;
    border-radius: 100rpx;
    background: linear-gradient(to right, #ffac30, #fc3d42);
    font-size: 30rpx;
    color: #fff;
    margin: 30rpx auto 20rpx;
    &:after {
      border: none;
    }
  }
  text {
    line-height: 2;
    color: #333;
  }
}
</style>
